import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form
} from "react-bootstrap";
import axios from "axios";
import "../styles/App.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { useMsal } from "@azure/msal-react";

export const Utils = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [lunchBreakDuration, setLunchBreakDuration] = useState(1);
  const [projectAssignments, setProjectAssignments] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [harvestUserId, setHarvestUserId] = useState(null);
  const [showBreakInputs, setShowBreakInputs] = useState(false);
  const defaultStartTime = new Date(); 
  defaultStartTime.setHours(9, 0, 0); // Set hours, minutes, seconds to 9:00:00
  const [startTime, setStartTime] = useState(defaultStartTime);
  const defaultEndTime = new Date(); 
  defaultEndTime.setHours(17, 0, 0); // Set hours, minutes, seconds to 17:00:00
  const [endTime, setEndTime] = useState(defaultEndTime);
  const [tasks, setTasks] = useState([]);
  const { accounts } = useMsal();
  const defaultBreakStartTime = new Date(); 
  defaultBreakStartTime.setHours(12, 0, 0); // Set hours, minutes, seconds to 12:00:00
  const [breakStartTime, setBreakStartTime] = useState(defaultBreakStartTime);
  const [breakDuration, setBreakDuration] = useState(30); // Default value if needed
  const userEmail = accounts[0] && accounts[0].username;

  useEffect(() => {
    fetchProjectAssignments();
  }, []);

  const HARVEST_API_URL = "https://api.harvestapp.com/v2/time_entries";

  const tokens = {
    staticToken: process.env.REACT_APP_STATIC_TOKEN,
    accountId: process.env.REACT_APP_ACCOUNT_ID,
  };

  


  const getHarvestUserId = async (email) => {
    try {
      const response = await axios.get("https://api.harvestapp.com/v2/users", {
        headers: {
          Authorization: `Bearer ${tokens.staticToken}`,
          "Harvest-Account-Id": `${tokens.accountId}`,
        },
        params: {
          email: email
        }
      });
  
      const users = response.data.users;
      const user = users.find(u => u.email === email);
      return user ? user.id : null;
    } catch (error) {
      console.error("Error fetching Harvest user ID:", error);
      return null;
    }
  };
  
  const fetchProjectAssignments = async () => {
    try {
       // Use this function in your component or where you need the Harvest user ID
      const harvestUserId = await getHarvestUserId(userEmail);
      setHarvestUserId(harvestUserId);
      const response = await axios.get(`https://api.harvestapp.com/v2/users/${harvestUserId}/project_assignments`, {
        headers: {
          Authorization: `Bearer ${tokens.staticToken}`,
          "Harvest-Account-Id": `${tokens.accountId}`,
        },
      });
      setProjectAssignments(response.data.project_assignments);
    } catch (error) {
      console.error("Error fetching project assignments:", error);
    }
  };

  const handleProjectChange = (e) => {
    const projectId = e.target.value;
    setSelectedProjectId(projectId);
    const selectedProject = projectAssignments.find(p => p.project.id.toString() === projectId);
    setTasks(selectedProject ? selectedProject.task_assignments : []);
  };

  const handleTaskChange = (e) => {
    setSelectedTaskId(e.target.value);
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // Adding 1 because getMonth() returns month from 0-11
    const day = date.getDate();
  
    // Ensuring two digits for month and day
    const formattedMonth = month < 10 ? `0${month}` : month;
    const formattedDay = day < 10 ? `0${day}` : day;
  
    return `${year}-${formattedMonth}-${formattedDay}`;
  };

  const getPreviousMonday = () => {
    const date = new Date();
    const day = date.getDay();
    const difference = date.getDate() - day - 7 + (day === 0 ? -6 : 1); // adjust when day is Sunday
    return new Date(date.setDate(difference));
  };

  const getPreviousSunday = () => {
    const date = new Date();
    const day = date.getDay();
    const difference = date.getDate() - day - (day === 0 ? 7 : 0); // Subtract the current day number from the current date to get the previous Sunday, and if it's already Sunday, subtract an additional 7 days to get the previous Sunday
    return new Date(date.setDate(difference));
  };

  const setPreviousWeek = () => {
    setStartDate(getPreviousMonday());
    setEndDate(getPreviousSunday());
  };

  async function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  
  const addHours = async () => {
    let currentDate = new Date(startDate);
    const endDateCopy = new Date(endDate);
    endDateCopy.setDate(endDateCopy.getDate() + 1); // Include the end date
  
    let success = true; // Flag to track if all API calls were successful
  
    while (currentDate < endDateCopy) {
      if (currentDate.getDay() !== 6 && currentDate.getDay() !== 0) { // Exclude weekends
        const spentDate = formatDate(currentDate);
  
        try {
          await axios.post(
            `${HARVEST_API_URL}?project_id=${selectedProjectId}&task_id=${selectedTaskId}&spent_date=${spentDate}&user_id=${harvestUserId}&hours=${lunchBreakDuration}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${tokens.staticToken}`,
                "Harvest-Account-Id": `${tokens.accountId}`,
              },
            }
          );
        } catch (error) {
          console.error("Error adding hours:", error);
          success = false; // Set flag to false if any API call fails
        }
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
  
    // Show alert based on success flag
    if (success) {
      alert("Hours inserted successfully");
    } else {
      alert("Error occurred while inserting hours");
    }
  };

  // Helper Functions
  function calculateBreakEndTime(breakStartTime, breakDuration) {
    const breakDate = new Date(breakStartTime);
    breakDate.setMinutes(breakDate.getMinutes() + breakDuration);
    return formatTimeFromDate(breakDate); // Changed from formatTime to formatTimeFromDate
}

  async function makeApiCall(date, startTime, endTime, projectId, taskId) {
    try {
        const spentDate = formatDate(date); 
        const startTimeFormatted = formatTime(date, startTime);
        const endTimeFormatted = formatTime(date, endTime);

        await axios.post(
            `${HARVEST_API_URL}?project_id=${projectId}&task_id=${taskId}&spent_date=${spentDate}&started_time=${startTimeFormatted}&ended_time=${endTimeFormatted}&user_id=${harvestUserId}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${tokens.staticToken}`,
                    "Harvest-Account-Id": `${tokens.accountId}`,
                },
            }
        );
        return true; // Indicate success
    } catch (error) {
        console.error("Error adding hours to Harvest:", error);
        return false; 
    }
  }

  async function addHoursWithStartEnd_Backup() {
    let currentDate = new Date(startDate);
    const endDateCopy = new Date(endDate);
    endDateCopy.setDate(endDateCopy.getDate() + 1); // Include the end date

    let success = true; // Flag to track if all API calls were successful

    while (currentDate < endDateCopy) {
        if (currentDate.getDay() !== 6 && currentDate.getDay() !== 0) { // Exclude weekends
            const spentDate = formatDate(currentDate);

            // Format your start and end times
            const startTimeFormatted = formatTime(currentDate, startTime);
            const endTimeFormatted = formatTime(currentDate, endTime);

            try {
                await axios.post(
                    `${HARVEST_API_URL}?project_id=${selectedProjectId}&task_id=${selectedTaskId}&spent_date=${spentDate}&started_time=${startTimeFormatted}&ended_time=${endTimeFormatted}&user_id=${harvestUserId}`,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${tokens.staticToken}`,
                            "Harvest-Account-Id": `${tokens.accountId}`,
                        },
                    }
                );
            } catch (error) {
                console.error("Error adding hours (start/end):", error);
                success = false;
            }
        }
        currentDate.setDate(currentDate.getDate() + 1);
    }

    // Show alert based on success flag
    if (success) {
        alert("Hours inserted successfully (start/end)");
    } else {
        alert("Error occurred while inserting hours (start/end)");
    }
}

async function addHoursWithStartEnd() {
  let currentDate = new Date(startDate);
  const endDateCopy = new Date(endDate);
  endDateCopy.setDate(endDateCopy.getDate() + 1); // Include the end date

  const LUNCH_BREAK_PROJECT_ID = "39719161"
  const LUNCH_BREAK_TASK_ID = "21966737"; 

  let success = true; // Flag to track if all API calls were successful

  while (currentDate < endDateCopy) {
      if (currentDate.getDay() !== 6 && currentDate.getDay() !== 0) { // Exclude weekends
          const spentDate = formatDate(currentDate);

          if (showBreakInputs) {
              // Entry 1: Start Time to Break Start
              const entry1Success = await makeApiCall(currentDate, startTime, breakStartTime, selectedProjectId, selectedTaskId);

              // Entry 2: Break Start to Break End
              const breakEndTime = calculateBreakEndTime(breakStartTime, breakDuration);
              const entry2Success = await makeApiCall(currentDate, breakStartTime, breakEndTime, LUNCH_BREAK_PROJECT_ID, LUNCH_BREAK_TASK_ID); 

              // Entry 3: Break End to End Time
              const entry3Success = await makeApiCall(currentDate, breakEndTime, endTime, selectedProjectId, selectedTaskId);

              success = success && entry1Success && entry2Success && entry3Success; // Update overall success

          } else {
              // No break: Single Entry
              const startTimeFormatted = formatTime(currentDate, startTime);
              const endTimeFormatted = formatTime(currentDate, endTime);
              const singleEntrySuccess = await makeApiCall(currentDate, startTimeFormatted, endTimeFormatted, selectedProjectId, selectedTaskId); 
              success = success && singleEntrySuccess;
          }
      } 
      currentDate.setDate(currentDate.getDate() + 1); 
  }

  // Show alert based on overall success flag
  if (success) {
      alert("Hours inserted successfully (start/end)");
  } else {
      alert("Error occurred while inserting hours (start/end)");
  }
}

  

  const copyTimesheet = async () => {
    // Placeholder for future copyTimesheet function
  };

  const retrieveTimesheet = async () => {
    // Implementation of retrieveTimesheet function
  };

  const formatTimeFromDate = (date) => {
    if (!date) return '';
    let hours = date.getHours();
    let minutes = date.getMinutes();
    hours = hours < 10 ? `0${hours}` : hours;
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${hours}:${minutes}`;
  };  

  function formatTime(date, time) {
    if (!date || !time) return null;

    // Ensure 'time' is a string
    if (typeof time !== 'string') {
        const hours = time.getHours();
        const minutes = time.getMinutes();
        time = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`; 
    }

    const dateObj = new Date(date);
    const [hours, minutes] = time.split(":");

    dateObj.setHours(hours);
    dateObj.setMinutes(minutes);

    return dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
}



  async function getUsers() {
    const response = await axios.get(
      "https://api.harvestapp.com/v2/users?is_active=true",
      {
        headers: {
          Authorization: `Bearer ${tokens.staticToken}`,
          "Harvest-Account-Id": `${tokens.accountId}`,
        },
        params: {
          per_page: 2000,
        },
      }
    );

    return response.data.users.map((user) => ({
      id: user.id.toString(),
      first_name: user.first_name,
      last_name: user.last_name,
      is_contractor: user.is_contractor,
      weekly_capacity: user.weekly_capacity / 3600, // convert seconds to hours
    }));
  }

  return (
    <Container>
        <Row className="justify-content-md-center">
            <Col md="auto">
                <h1 className="center-text title">Timesheet Utilities</h1>
                <Row className="justify-content-md-center no-wrap">
                    <Col md="auto" className="mr-3">
                        <div className="d-flex flex-column">
                            <label className="labelColor h2 font-weight-bold">Start Date</label>
                            <DatePicker
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                selectsStart
                                startDate={startDate}
                                endDate={endDate}
                            />
                        </div>
                    </Col>
                    <Col md="auto" className="mr-3">
                        <div className="d-flex flex-column">
                            <label className="labelColor h2 font-weight-bold">End Date</label>
                            <DatePicker
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                selectsEnd
                                startDate={startDate}
                                endDate={endDate}
                                minDate={startDate}
                            />
                        </div>
                    </Col>
                    <Col md="auto" className="mr-3">
                        <div className="d-flex flex-column">
                            <label className="labelColor h2 font-weight-bold">Start Time</label>
                            <input 
                                type="time" 
                                value={formatTimeFromDate(startTime)}
                                onChange={(e) => {
                                  const newTime = new Date(startTime);
                                  const [hours, minutes] = e.target.value.split(':');
                                  newTime.setHours(parseInt(hours, 10), parseInt(minutes, 10));
                                  setStartTime(newTime);
                                }}
                                className="form-control"
                            />
                        </div>
                    </Col>
                    <Col md="auto" className="mr-3">
                        <div className="d-flex flex-column">
                            <label className="labelColor h2 font-weight-bold">End Time</label>
                            <input 
                                type="time" 
                                value={formatTimeFromDate(endTime)}
                                onChange={(e) => {
                                  const newTime = new Date(endTime);
                                  const [hours, minutes] = e.target.value.split(':');
                                  newTime.setHours(parseInt(hours, 10), parseInt(minutes, 10));
                                  setEndTime(newTime);
                                }}
                                className="form-control"
                            />
                        </div>
                    </Col>
                    {showBreakInputs && (
                    <> {/* Wrap the break inputs with this to show conditionally */}
                        <Col md="auto" className="mr-3">
                            <div className="d-flex flex-column">
                                <label className="labelColor h2 font-weight-bold">Break Start Time</label>
                                <input 
                                    type="time" 
                                    value={formatTimeFromDate(breakStartTime)} 
                                    onChange={(e) => {
                                        const newTime = new Date(breakStartTime);
                                        const [hours, minutes] = e.target.value.split(':');
                                        newTime.setHours(parseInt(hours, 10), parseInt(minutes, 10));
                                        setBreakStartTime(newTime);
                                    }}
                                    className="form-control"
                                />
                            </div>
                        </Col>
                        <Col md="auto" className="mr-3">
                            <div className="d-flex flex-column">
                                <label className="labelColor h2 font-weight-bold">Break Duration (minutes)</label>
                                <input 
                                    type="number" 
                                    value={breakDuration} 
                                    onChange={(e) => setBreakDuration(e.target.value)} 
                                    className="form-control"
                                />
                            </div>
                        </Col>
                    </> 
                )}
                </Row>

                {/* Project and Task Selection */}
                <Row className="justify-content-md-center no-wrap mt-3">
                    <Form>
                        <Form.Group controlId="projectSelect">
                            <Form.Label>Project</Form.Label>
                            <Form.Control as="select" value={selectedProjectId} onChange={handleProjectChange}>
                                <option value="">Select a Project</option>
                                {projectAssignments.map((assignment) => (
                                    <option key={assignment.project.id} value={assignment.project.id}>
                                        {assignment.project.name}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="taskSelect">
                            <Form.Label>Task</Form.Label>
                            <Form.Control as="select" value={selectedTaskId} onChange={handleTaskChange} disabled={!selectedProjectId}>
                                <option value="">Select a Task</option>
                                {tasks.map((taskAssignment) => (
                                    <option key={taskAssignment.task.id} value={taskAssignment.task.id}>
                                        {taskAssignment.task.name}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form>
                </Row>

                <Row className="justify-content-md-center no-wrap mt-3">
                    <Col md="auto" className="mr-3"> 
                        <button onClick={() => setShowBreakInputs(!showBreakInputs)} className="customButton">
                            {showBreakInputs ? "Hide Break" : "Show Break"} 
                        </button> 
                    </Col>
                    <Col md="auto" className="mr-3">
                        <button onClick={retrieveTimesheet} className="customButtonDisabled" disabled="{true}">
                            Retrieve My Timesheet
                        </button>
                    </Col>
                    <Col md="auto" className="mr-3">
                        <button onClick={copyTimesheet} className="customButtonDisabled" disabled="{true}">
                            Copy Timesheet
                        </button>
                    </Col>
                    
                    <Col md="auto" className="mr-3">
                        <button 
                            onClick={addHoursWithStartEnd} 
                            className={`customButton ${!startDate || !endDate || !selectedProjectId || !selectedTaskId ? 'customButtonDisabled' : ''}`}
                            disabled={!startDate || !endDate || !selectedProjectId || !selectedTaskId}
                        >
                            Add Hours
                        </button>
                    </Col>
                </Row>
            </Col>
        </Row>
    </Container>
);


  

  
  
};
